import { __extends } from "tslib";
/*istanbul ignore next */
var NotFoundError = /** @class */ (function (_super) {
    __extends(NotFoundError, _super);
    function NotFoundError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, NotFoundError.prototype);
        return _this;
    }
    return NotFoundError;
}(Error));
export { NotFoundError };
//# sourceMappingURL=NotFoundError.js.map